<template>
<div>
<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">
<ContentHeader :title="$store.state.languages.lang_phrases.tedarikci_markalari"  :show_button="false" ></ContentHeader>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>



<div class="content_card_content" v-if="!loading">


<template v-if="!data.length">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">Henüz hiç kayıt oluşturulmamış</h3>

</div>
</template>

<template v-else>
<ContentTable :data="data" :columns="columns" routename="SupplierBrand"  @dataDeleted="getData" identifier_row="uuid" identifier_row_name="supplier_uuid"></ContentTable>
</template>


</div>


  


</div>







</div>
</template>

<script>
export default {

  name: 'SupplierBrands',

   data () {
     return {
      data:[],
      loading:true,
      columns:[  
      {
        type:"text",
        field:"brand_name",        
        with_route:true,
        header:"marka",
        hide_on_mobile:false,
      },
      {
        type:"text",
        field:"supplier_name",
        header:"aktif_tedarikci",
        hide_on_mobile:false,
      }, 
      {
        type:"text",
        field:"supplier_code",
        header:"tedarikci_kodu",
        hide_on_mobile:false,
      },     
      {
        type:"text",
        field:"projects_count",
        header:"aktif_proje",
        hide_on_mobile:false,
      },
      ]
    }
  },
   mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
  	{
      this.loading = await true
      console.log(this.$store.state.auth)
  		let data = await this.generalApiGet("supplier_brands") 
      console.log(data);
      for(let item of data)
      {
        item.brand_name = item.supplier.brand.name
        item.supplier_name = item.supplier.name
        item.supplier_code = item.supplier.suppliercode
        item.projects_count = item.supplier.projectsuppliers.length        
        item.uuid = item.supplier.uuid
      }
      this.data = await data
      this.loading = await false
      console.log(this.data);
  	},
  	
  }
};
</script>

<style lang="css" scoped>
</style>